// ABOUTME: Title of an entity page (node, object schema form, short list): a secondary-coloured slash
// ABOUTME: followed by the bold primary h5 title, so every page names its subject the same way.

import { Box, Stack, Typography } from '@ds/coolshop';
import { PropsWithChildren } from 'react';

export type PageTitleProps = PropsWithChildren<{
    /** Top margin, in theme spacing units. */
    mt?: number;
}>;

/** 45° stroke with square ends drawn beside the title; sized in em so it follows the font size. */
const TitleSlash = () => (
    <Box display="flex" flexShrink={0} color="secondary.main">
        {/* Spans the cap height of the title text. */}
        <svg
            width="0.85em"
            height="0.85em"
            viewBox="0 0 16 16"
            aria-hidden="true"
            focusable="false"
        >
            <line x1="1.5" y1="14.5" x2="14.5" y2="1.5" stroke="currentColor" strokeWidth="2.5" />
        </svg>
    </Box>
);

export const PageTitle = ({ mt, children }: PageTitleProps) => (
    <Stack direction="row" alignItems="center" gap={1.5} mt={mt} overflow="hidden">
        <Typography variant="h5" color="primary.main" overflow="hidden" textOverflow="ellipsis">
            <Stack direction="row" alignItems="center" gap={1.5}>
                <TitleSlash />
                <Box overflow="hidden" textOverflow="ellipsis" whiteSpace="nowrap">
                    <b>{children}</b>
                </Box>
            </Stack>
        </Typography>
    </Stack>
);
